export * from '@primeuix/themes/nora/inputnumber';
export { default } from '@primeuix/themes/nora/inputnumber';
